import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class EditProjectService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  private url(path: string): string {
    const base =
      this.authService.getOriginCurrency() !== 'BRL'
        ? environment.intlUrl
        : environment.apiUrl;

    return `${base}${path}`;
  }

  updateProject(payload: any) {
    return this.http.put<any>(this.url('/account-adm-loteria-password'), payload);
  }
}